import axios from '../plugins/axios.js';
import InvalidPayload from '../exceptions/InvalidPayload.js';

export default {
    async getActive(leadId) {
        if (!leadId) {
            throw new InvalidPayload('LeadId not provided.');
        }

        const response = await axios.get(`v1/leads/${leadId}/visits`);

        return response.data.data;
    },

    async store(leadId, payload = {}) {
        if (!leadId) {
            throw new InvalidPayload('LeadId not provided.');
        }

        const response = await axios.post(`v1/leads/${leadId}/visits`, payload);

        return response.data.data;
    },

    async update(leadId, payload = {}) {
        if (!leadId) {
            throw new InvalidPayload('LeadId not provided.');
        }

        const response = await axios.put(`v1/leads/${leadId}/visits`, payload);

        return response.data.data;
    },

    async delete(leadId, payload = {}) {
        if (!leadId) {
            throw new InvalidPayload('LeadId not provided.');
        }

        const response = await axios.delete(`v1/leads/${leadId}/visits`, payload);

        return response.data;
    },
};
